import { createSelector } from 'reselect';
import { getSlice } from './deviations';

export const getPresetsStatus = createSelector(getSlice, slice => slice.presetsStatus);

export const getPresetsInitResponse = createSelector(getSlice, slice => slice.presetsInit);

export const getPresetsPrompt = createSelector(getSlice, slice => slice.presetsPrompt);
